import { createComponent } from '@ycos/fela'
import { getFontStyles } from '../'

const Blockquote = createComponent(
  'Blockquote',
  ({ theme, noBottomMargin }) => {
    const {
      spacingMultiplier,
      typography,
      custom: { quote }
    } = theme

    return {
      ...getFontStyles(typography, { type: 'Heading', name: quote.name }),
      color: quote.color,
      fontStyle: quote.fontStyle,
      margin: `0 0 ${noBottomMargin ? 0 : spacingMultiplier}px`,
      padding: '0',
      direction: 'ltr'
    }
  },
  'blockquote'
)

export default Blockquote
